export default "__VITE_ASSET__BQCBH4Qi__"